// extracted by mini-css-extract-plugin
export var lessons = "style-module--lessons--3bf83";
export var lessons__descr = "style-module--lessons__descr--86d0a";
export var lessons__imgCover = "style-module--lessons__img-cover--bc382";
export var lessons__item = "style-module--lessons__item--8098f";
export var lessons__list = "style-module--lessons__list--c1610";
export var lessons__text = "style-module--lessons__text--cd970";
export var lessons__textBold = "style-module--lessons__text--bold--65569";
export var lessons__textMargin = "style-module--lessons__text--margin--97075";
export var rocket = "style-module--rocket--2cd80";